// Formas de visualização DERIVADAS do formato do resultado (não é escolha de gosto).
// A tabela declara o tipo de cada campo, então sabemos o que é tempo (data), o
// que é categoria e o que é somável — e oferecemos só as formas válidas.
// A TABELA está sempre presente. Pizza só quando cabe (≤ 5 fatias).

const STAMPED_TIME = new Set(["createdAt", "updatedAt"]);

export const isTimeDim = (campo, fields) => {
  if (STAMPED_TIME.has(campo)) return true;
  const f = (fields || []).find(x => x.name === campo);
  return !!f && f.type === "data";
};

export const measureLabel = m => {
  const t = m.tipo || "contagem";
  const nomes = { contagem: "contagem", contagem_distinta: "distintos", soma: "soma", media: "média", minimo: "mínimo", maximo: "máximo" };
  return m.campo ? `${nomes[t] || t} de ${m.campo}` : nomes[t] || t;
};

export const dimLabel = (d, fields) => {
  const f = (fields || []).find(x => x.name === d.campo);
  const base = f ? f.label || f.name : d.campo === "createdAt" ? "Criado em" : d.campo;
  return d.granularidade ? `${base} (${d.granularidade})` : base;
};

// quais formas são válidas para (dimensões, medidas, tipos de campo)
export const allowedForms = (spec, fields) => {
  const dims = spec.dimensoes || [];
  const measures = spec.medidas && spec.medidas.length ? spec.medidas : [{ tipo: "contagem" }];
  const forms = [{ value: "tabela", label: "Tabela" }]; // sempre disponível
  const oneMeasure = measures.length === 1;

  if (dims.length === 0 && oneMeasure) {
    forms.unshift({ value: "numero", label: "Número único" });
  }
  if (dims.length === 1 && oneMeasure) {
    const time = isTimeDim(dims[0].campo, fields);
    forms.push({ value: "barras", label: "Barras" });
    if (time) forms.push({ value: "linha", label: "Linha" });
    forms.push({ value: "pizza", label: "Pizza (poucas fatias)" });
  }
  if (dims.length === 2 && oneMeasure) {
    forms.push({ value: "tabela_cruzada", label: "Tabela cruzada" });
    const anyTime = isTimeDim(dims[0].campo, fields) || isTimeDim(dims[1].campo, fields);
    if (anyTime) forms.push({ value: "barras_empilhadas", label: "Barras empilhadas" });
  }
  return forms;
};

// ---- moldagem das linhas do summary (d0,d1,…,m0) ----

// número único
export const toNumber = result => {
  const r = (result.rows && result.rows[0]) || {};
  return r.m0 != null ? r.m0 : 0;
};

// tabela plana: colunas = dimensões (rótulos) + medidas
export const toTable = (result, spec, fields) => {
  const dims = spec.dimensoes || [];
  const measures = spec.medidas && spec.medidas.length ? spec.medidas : [{ tipo: "contagem" }];
  const cols = [
    ...dims.map((d, i) => ({ key: `d${i}`, label: dimLabel(d, fields) })),
    ...measures.map((m, i) => ({ key: `m${i}`, label: measureLabel(m) })),
  ];
  return { cols, rows: result.rows || [] };
};

// série 1D: [{ name, valor }] para barras/linha/pizza
export const toSeries = result => (result.rows || []).map(r => ({ name: String(r.d0 ?? ""), valor: Number(r.m0 || 0) }));

// pivô 2D: linhas = d0, colunas = valores distintos de d1, célula = m0
export const toPivot = result => {
  const rows = result.rows || [];
  const colSet = [];
  const map = new Map(); // d0 -> { d1 -> m0 }
  for (const r of rows) {
    const a = String(r.d0 ?? "");
    const b = String(r.d1 ?? "");
    if (!colSet.includes(b)) colSet.push(b);
    if (!map.has(a)) map.set(a, {});
    map.get(a)[b] = Number(r.m0 || 0);
  }
  const data = Array.from(map.keys()).map(a => {
    const row = { name: a };
    for (const b of colSet) row[b] = map.get(a)[b] || 0;
    return row;
  });
  return { cols: colSet, data };
};
